<birdz-modal>
  <div modal-body class="body">
    <mat-accordion>
      <mat-expansion-panel [expanded]="true">
        <mat-expansion-panel-header>
          <mat-panel-title>{{ 'CHART_LEGEND' | transloco }}</mat-panel-title>
        </mat-expansion-panel-header>
        <div class="legend">
          @for (kpi of data.kpis; track kpi) {
            <div class="legend-item">
              <div class="legend-item__symbol" [style.--legend-item-color]="kpi.color"></div>
              <div class="legend-item__title">{{ kpi.label }}</div>
              <div class="legend-item__desc">{{ kpi.desc }}</div>
            </div>
          }
        </div>
      </mat-expansion-panel>
    </mat-accordion>
  </div>
</birdz-modal>
